import { Box } from "@mui/material";
import {
  CustomAutocomplete,
  CustomDropdown,
  CustomFileInput,
  CustomNumberInput,
  CustomTextarea,
  CustomTextInput,
} from "components/atoms";
import ButtonCheckbox from "components/atoms/CheckboxButton";
import CustomeFilePreview from "components/atoms/CustomeFilePreview";
import { cloneDeep } from "lodash";
import React, { useState } from "react";

const CustomDynamicForTable = (props) => {
  const {
    element: orgElement,
    elementIndex,
    currentData,
    data,
    elements,
    sx = {},
    cellRef,
    parantRender,
    specificRender,
    path = [],
    handleSpecificDynamicType = false,
  } = props;
  let element = orgElement;

  // clean refrence and make new refrence
  const newRefrence = {
    specificData: currentData,
    dynamicType: elements,
    currentDynamicType: element,
    allData: data,
    currentIndex: elementIndex,
  };

  const [_, forceUpdate] = useState({});
  const render = () => forceUpdate({});

  const value = cellRef[element?.uniqueName];

  const passCurrentData = {
    dynamicType: element,
    index: elementIndex,
    ...(currentData && { currentData }),
    ...(data && { data }),
    allDynamicTypes: elements,
    values: cellRef,
    path,
  };

  const handleChange = (newValue) => {
    cellRef[element?.uniqueName] = newValue;
    !!element?.allReRender ? parantRender() : render();
    !!element?.reRender
      ? specificRender(
          cloneDeep({
            value,
            ...newRefrence,
          })
        )
      : null;
  };

  if (!!handleSpecificDynamicType) {
    Object.keys(handleSpecificDynamicType).forEach((key) => {
      if (key === path.filter((p) => typeof p !== "number").join(".")) {
        const { type = "row", handler = () => {} } =
          handleSpecificDynamicType[key];
        if (type === "row") {
          const newData = handler(
            cloneDeep({ ...passCurrentData, currentValue: value })
          );
          if (Object.keys(newData).includes("uniqueName", "name", "type")) {
            element = newData;
          }
        }
      }
    });
  }

  if (element?.type === "number") {
    let defaultValueAtFirst = false;
    if (
      !element?.MinMaxAlert &&
      (value === "" ||
        value?.length === 0 ||
        (value < element?.minValue &&
          !!element?.minValue &&
          element?.minValue !== 0))
    ) {
      cellRef[element?.uniqueName] = element?.minValue;
      defaultValueAtFirst = element?.minValue;
    }

    return (
      <Box
        sx={{
          minWidth: "200px",
          maxWidth: "200px",
        }}
      >
        <CustomNumberInput
          isLabel={element?.isLabel}
          label={`Enter ${element?.name}`}
          name={element?.uniqueName}
          value={defaultValueAtFirst !== false ? defaultValueAtFirst : value}
          onChange={(e) => {
            handleChange(e?.target?.value);
          }}
          sx={{
            ...(!!element?.sx ? element?.sx : {}),
            ...sx,
          }}
          minValue={element?.minValue}
          maxValue={element?.maxValue}
          MinMaxAlert={element?.MinMaxAlert}
          disabled={element?.isReadOnly ?? false}
        />
      </Box>
    );
  } else if (element?.type === "dropdown") {
    return (
      <Box
        sx={{
          minWidth: "200px",
          maxWidth: "200px",
        }}
      >
        <CustomDropdown
          isLabel={element?.isLabel}
          label={`Enter ${element?.name}`}
          name={element.uniqueName}
          value={value}
          onChange={(value) => {
            handleChange(value);
          }}
          multiple={element?.multiple ?? false}
          options={element?.options}
          sx={{
            ...(!!element?.sx ? element?.sx : {}),
            ...sx,
          }}
          renderOptionKey={
            element?.renderOptionValue ? element?.renderOptionValue : false
          }
        />
      </Box>
    );
  } else if (element?.type === "text") {
    return (
      <Box
        sx={{
          minWidth: "200px",
          maxWidth: "200px",
        }}
      >
        <CustomTextInput
          isLabel={element?.isLabel}
          label={`Enter ${element?.name}`}
          name={element.uniqueName}
          value={value}
          onChange={(e) => {
            handleChange(e?.target?.value);
          }}
          sx={{
            ...(!!element?.sx ? element?.sx : {}),
            ...sx,
          }}
        />
      </Box>
    );
  } else if (element?.type === "checkbox-btn") {
    return (
      <Box
        sx={{
          minWidth: "200px",
          maxWidth: "200px",
        }}
      >
        <ButtonCheckbox
          value={value}
          onChange={(e) => {}}
          trueLabel="Available"
          falseLabel="Unavailable"
          color="success"
        />
      </Box>
    );
  } else if (element?.type === "dynamicDropdown") {
    return (
      <Box
        sx={{
          minWidth: "200px",
          maxWidth: "200px",
        }}
      >
        <CustomAutocomplete
          label={element?.name}
          name={element?.uniqueName}
          value={value}
          onChange={(value) => {
            handleChange(value);
          }}
          options={element?.options ?? []}
          multiple={element?.multiple}
          freeSolo={element?.freeSolo ?? true}
          //   error={error}
          //   helperText={errorMsg}
          //   isLock={isLock || isDisable}
          isReadOnly={!!element?.isReadOnly}
          renderOptionKey={
            element?.renderOptionValue ? element?.renderOptionValue : false
          }
          isLabel={element?.isLabel}
          sx={{
            ...(!!element?.sx ? element?.sx : {}),
            ...sx,
          }}
        />
      </Box>
    );
  } else if (element?.type === "textarea") {
    return (
      <Box
        sx={{
          minWidth: "200px",
          maxWidth: "200px",
          ...(!!element?.sx ? element?.sx : {}),
          ...sx,
        }}
      >
        <CustomTextarea
          isLabel={element?.isLabel}
          label={element?.name}
          name={element?.uniqueName}
          value={value ?? ""}
          onChange={(e) => handleChange(e?.target?.value)}
          isReadOnly={!!element?.isReadOnly}
        />
      </Box>
    );
  } else if (element?.type === "file") {
    if (value) {
      // ✅ Show preview if API returned a file (metadata or File)
      return <CustomeFilePreview files={value} />;
    }
    return (
      <Box
        sx={{
          minWidth: "200px",
          maxWidth: "200px",
          ...(!!element?.sx ? element?.sx : {}),
          ...sx,
        }}
      >
        <CustomFileInput
          isLabel={element?.isLabel}
          label={element?.name}
          name={element?.uniqueName}
          value={value}
          onChange={(e) => {
            handleChange(e?.target?.value);
          }}
          multiple={element?.multiple}
          isReadOnly={!!element?.isReadOnly}
        />
      </Box>
    );
  }
};

export default CustomDynamicForTable;
